/* TODO: Warning! Удалить компонент после тестов валюты на проде SKY-3296 */
<template>
  <li
    class="gold-card transition--color-bg"
    @click="emitServer">
    <div class="gold-card__main">
      <p class="gold-card__title">
        {{ server.title }} {{ server._id }}
      </p>

      <ol class="gold-card__tags">
        <li class="gold-card__tag">
          {{ activeRegion.title }}
        </li>

        <li class="gold-card__tag">
          {{ server._faction.title }}
        </li>
      </ol>
    </div>

    <div class="gold-card__time">
      <p class="gold-card__time-text">
        {{ server._deliveryTimeFormatted }} delivery time
      </p>
    </div>

    <p class="gold-card__golds transition--color">
      <template v-if="goldAmountFormatted">
        {{ goldAmountFormatted }} Gold in stock
      </template>
    </p>

    <div class="gold-card__additional">
      <div class="gold-card__price">
        <upper-cents-price
          class="gold-card__price-main"
          :sum="currentPrice" />

        <p class="gold-card__price-count">
          For {{ server.range.step | transformBigNumber }} gold
        </p>
      </div>

      <button
        class="button gold-card__button button-main--dark-hover"
        type="button">
        <img
          data-src="/images/icons/shield.svg"
          class="lazyload gold-card__button-img"
          width="14"
          height="14"
          alt="">
        Buy Now
      </button>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { formatNumberAsMoney, transformBigNumber } from 'Root/helpers/tools';
import UpperCentsPrice from 'Components/ui/Price/UpperCentsPrice.vue';

export default {
  name: 'GameOfferGoldItem',

  components: { UpperCentsPrice },

  filters: {
    transformBigNumber,
  },

  props: {
    server: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(['activeRegion']),
    ...mapGetters(['currencySymbol']),

    currentPrice() {
      const { borderValues, prices } = this.server.range;

      return prices?.[this.activeRegion.id]?.[borderValues?.[0]];
    },

    goldAmountFormatted() {
      if (this.server.goldInfo?.[this.server._faction.id].goldInStock) {
        return formatNumberAsMoney(
          this.server.goldInfo[this.server._faction.id].goldInStock,
          { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        );
      }

      return null;
    },
  },

  methods: {
    emitServer() {
      this.$emit('select-server', this.server);
    },
  },
};
</script>

<style scoped lang="scss">
.gold-card {
  background-color: $color--basic-black;
  border: 1px solid $color--basic-menu;
  border-radius: 10px;
  display: grid;
  grid-gap: 8px;
  align-items: center;
  padding: 16px;
  line-height: 1.2;
  font-weight: 500;
  transition-property: background-color, border-color;

  &:hover {
    background-color: rgba($color--basic-blue, 0.25);
    border-color: $color--basic-blue;

    .gold-card__golds {
      color: currentColor;
    }
  }
}

.gold-card__additional {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.gold-card__title {
  font-size: 19px;
  font-weight: 500;
}

.gold-card__tags {
  display: flex;
  flex-wrap: wrap;
  margin: 8px -4px 0;
  overflow: hidden;
}

.gold-card__tag {
  background-color: $color--basic-blue;
  font-size: 11px;
  padding: 5px 6px 6px;
  border-radius: 4px;
  margin: 8px 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.gold-card__time {
  position: relative;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    mask: url('/images/icons/clock.svg') no-repeat center;
    -webkit-mask: url('/images/icons/clock.svg') no-repeat center;
    mask-size: cover;
    -webkit-mask-size: cover;
    width: 16px;
    height: 16px;
    background-color: currentColor;
    margin-right: 8px;
    flex-shrink: 0;
  }
}

.gold-card__time-text {
  font-size: 13px;
}

.gold-card__golds {
  color: $color--basic-dark-gray;
  font-size: 13px;
}

.gold-card__price-main {
  --font-size--cent: 0.6em;

  font-size: 17px;
}

.gold-card__price-count {
  font-size: 11px;
}

.gold-card__button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  text-transform: none;
  font-size: 13px;
  margin-left: 32px;
}

.gold-card__button-img {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

@media only screen and (max-width: 1023.2px) {
  .gold-card__golds, .gold-card__main {
    order: -1;
  }
}

@media only screen and #{$screen-more-or-1024} {
  .gold-card {
    padding-right: 32px;
    grid-gap: 32px;
    grid-auto-flow: column;
    grid-template-columns: 1fr 120px max-content max-content;
  }

  .gold-card__time {
    &:before {
      width: 24px;
      height: 24px;
    }
  }

  .gold-card__golds {
    font-size: 15px;
    min-width: 190px;
    text-align: right;
  }

  .gold-card__price {
    min-width: 70px;
  }

  .gold-card__price-main {
    font-size: 25px;
  }

  .gold-card__price-count {
    font-size: 13px;
  }

  .gold-card__button {
    font-size: 15px;
  }

  .gold-card__button-img {
    width: 20px;
    height: 20px;
  }
}
</style>
